import React, { Component } from 'react';
import NewRoundForm from './NewRoundForm'
import axios from 'axios'
const BASE_URL = process.env.REACT_APP_BACKEND_URL;


class RoundController extends Component {
  constructor(props){
    super(props);
    console.log(super(props))
    this.state = {
      file: null
    };

    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleFileUpload(files){
    alert("RECIEVED FILES!")
    for(let i=0; i < files.length; i++){
      console.log(files[i].name);
    }
    this.setState({file: files[0]});
  }

  handleSubmit(){
    var formData = new FormData();
    formData.append("file", this.state.file);
    axios.post(BASE_URL+'/admin/load_apps', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Access-Control-Allow-Origin": "*"
        }
    })
    .then(function (response) {
      alert(response);
      console.log(response);
    })
    .catch(function (error) {
      alert(error);
      console.log(error);
    })
  }

  render(){
    return (

      <div>
        <label>
          Manual Import
          <NewRoundForm/>
        </label>

      </div>

      
    )
  }
}

export default RoundController;


// WEBPACK FOOTER //
// ./src/components/admin/RoundController.js